// extracted by mini-css-extract-plugin
export default {"title":"style_m_title__jcpc3","time":"style_m_time__c6gSi","content":"style_m_content__v1rxd"};